import { render, staticRenderFns } from "./personadd.vue?vue&type=template&id=54e4b461"
import script from "./personadd.vue?vue&type=script&lang=js"
export * from "./personadd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports